<template>
  <div>
    <div class="anz-fc-emoji-categories">
      <template v-for="emoji in emojiList" :key="emoji">
        <button @click="$emit('insert-emoji', emoji)" @mousedown.prevent="">
          <span>{{ emoji }}</span>
        </button>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useEmojis from '@/composables/emojis/emojis'

export default defineComponent({
  name: 'EmojiPicker',
  emits: ['insert-emoji'],
  setup() {
    const { emojiList } = useEmojis()

    return {
      emojiList,
    }
  },
})
</script>
